<div class="vendor-rep">
  <div class="shell">
    <nav class="crumb">
      <span>Vendor Management</span><span class="sep">›</span><span class="here">Dashboard</span>
    </nav>

    <!-- Page header -->
    <div class="pagehead">
      <div class="idblock">
        <h1>{{ vendorName }}</h1>
      </div>
      <div class="head-actions">
        <button class="btn primary" (click)="goToOpenPositions()">Open Positions</button>
        <div class="icon-container" (click)="toggleMenu($event)">
          <button class="btn icon" aria-label="More">
            <i class="material-icons">more_vert</i>
          </button>
          <div class="popup-menu" *ngIf="showMenu">
            <div class="menu-item" (click)="navigateTo(routesEnum.quarterlyFeedback); $event.stopPropagation()">
              {{ quarterlyFeedback.quarterlyFeedbackText }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Top row -->
    <div class="grid">
      <div class="col-left">
        <div class="card">
          <app-vendor-contractor-headcount></app-vendor-contractor-headcount>
        </div>
        <div class="card">
          <app-interview-status></app-interview-status>
        </div>
      </div>
      <div class="card up-card">
        <app-upcoming-interviews></app-upcoming-interviews>
      </div>
    </div>

    <!-- Timesheet -->
    <div class="section">
      <app-timesheet></app-timesheet>
    </div>

    <!-- Performance Evaluation -->
    <div class="section">
      <app-performance-evalution></app-performance-evalution>
    </div>
  </div>
</div>
